import { takeEvery } from 'redux-saga/effects'

import { showSuccess } from 'store/entities/toastr/utils'
import { FEEDBACK_SENT } from 'app/constants/toastrMessages'
import { setProtrackRating, getIdentityProgress } from 'store/entities/identity/actions'

export default function* denialBlockSuccessSaga() {
  yield takeEvery(setProtrackRating.success.toString(), handleSetProtrackRatingSuccessHandler)
}

export function* handleSetProtrackRatingSuccessHandler() {
  showSuccess({ content: FEEDBACK_SENT })
  yield getIdentityProgress.call()
}
